import { styled } from '@mui/material/styles';

export const StoreBadgesContainer = styled('div')(() => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	gap: 36,
	marginBottom: '38px',
}));

export const StoreBadgesImageWrapper = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	height: 60,
	cursor: 'pointer',
}));

export const StoreBadgesGoogPlayImage = styled('img')(() => ({
	width: 140,
	height: 60,
}));
